export default {
  content: 'Contenido',
  feature: 'Funcionalidad',
  maintenance: 'Mantenimiento',
  ephemeride: 'Efemérides',
  general: 'General',
  teachersTraining: 'Acompañamiento docente'
}

export const en = {
  content: 'Content',
  feature: 'Functionality',
  maintenance: 'Maintenance',
  ephemeride: 'Events',
  general: 'General',
  teachersTraining: 'Teacher guidance'
}

export const ca = {
  content: 'Contingut',
  feature: 'Funcionalitat',
  maintenance: 'Manteniment',
  ephemeride: 'Efemèrides',
  general: 'General',
  teachersTraining: 'Acompanyament docent'
}
